{
	"add": "Add",
	"allPeople": "All people",
	"ariaCreateBackgroundMask": "Create Background Mask",
	"ariaCreateBrushMask": "Create Brush Mask",
	"ariaCreateGradientMask": "Create Gradient Mask",
	"ariaCreateNewMask": "Create New Mask",
	"ariaCreateRadialMask": "Create Radial Mask",
	"ariaCreateSkyMask": "Create Sky Mask",
	"ariaCreateSubjectMask": "Create Subject Mask",
	"ariaDeleteMask": "Delete Mask",
	"ariaFloatingMasksPanel": "Floating Masks Panel",
	"ariaHideMask": "Hide Mask",
	"ariaMaskGroup": "Mask Group",
	"ariaRenameMask": "Rename Mask",
	"ariaShowMask": "Show Mask",
	"ariaToggleMaskOverlay": "Toggle Mask Overlay",
	"background": "Background",
	"brush": "Brush",
	"couldNotDetectPeople": "Could not detect people",
	"create": "Create",
	"createIndividualMasks": "Create individual masks",
	"createIndividualMasksCount_one": "Create {{count}} individual mask",
	"createIndividualMasksCount_other": "Create {{count}} individual masks",
	"createNewMask": "Create New Mask",
	"createSelectedPeopleMasks": "Create Selected People Masks",
	"entirePerson": "Entire Person",
	"facialHair": "Facial Hair",
	"linearGradient": "Linear Gradient",
	"mask": "mask: {{name}}, {{type}}{{var2}}",
	"maskGroup": "mask group: {{var0}}",
	"masks": "Masks",
	"noPeopleDetected": "No people detected",
	"people": "People",
	"radialGradient": "Radial Gradient",
	"renameMask": "Rename Mask",
	"renameMaskGroup": "Rename Mask Group",
	"showOverlay": "Show Overlay",
	"sky": "Sky",
	"subject": "Subject",
	"subtract": "Subtract",
	"teeth": "Teeth"
}
